import React, { useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import NavbarFooterWrapper from "./NavbarFooterWrapper";
import {
  blogPosts,
  sortPostsByDateDesc,
  getPostBySlug,
  getPostIndexBySlug,
  searchPosts,
} from "./blogData";

const BlogPostPage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [query, setQuery] = useState("");

  const ordered = useMemo(() => sortPostsByDateDesc(blogPosts), []);
  const currentIndex = useMemo(() => getPostIndexBySlug(slug || ordered[0]?.slug), [slug, ordered]);
  const post = useMemo(() => {
    if (slug) return getPostBySlug(slug);
    return ordered[0];
  }, [slug, ordered]);

  const results = useMemo(() => searchPosts(query), [query]);

  const goPrev = () => {
    if (currentIndex < 0) return;
    const nextIdx = currentIndex + 1;
    if (nextIdx < ordered.length) navigate(`/blog/${ordered[nextIdx].slug}`);
  };

  const goNext = () => {
    if (currentIndex < 0) return;
    const prevIdx = currentIndex - 1;
    if (prevIdx >= 0) navigate(`/blog/${ordered[prevIdx].slug}`);
  };

  if (!post) {
    return (
      <NavbarFooterWrapper>
        <section className="blog">
          <div className="container">
            <h1>Blog</h1>
            <p>No posts yet.</p>
          </div>
        </section>
      </NavbarFooterWrapper>
    );
  }

  return (
    <NavbarFooterWrapper>
      <section className="blog">
        <div className="container">
          <div className="blog-header">
            <h1 className="blog-title">{post.title}</h1>
            <div className="blog-meta">
              <span>{new Date(post.date).toLocaleDateString()}</span>
              {post.author ? <span> · {post.author}</span> : null}
            </div>
          </div>

          <div className="blog-actions">
            <div className="nav-arrows">
              <button className="secondary-btn" onClick={goPrev} disabled={currentIndex === ordered.length - 1}>
                ← Previous
              </button>
              <button className="secondary-btn" onClick={goNext} disabled={currentIndex === 0}>
                Next →
              </button>
            </div>
            <div className="blog-links">
              <Link to="/blog/all" className="text-link">See all blogs</Link>
            </div>
          </div>

          <article className="blog-content" dangerouslySetInnerHTML={{ __html: post.content }} />

          <div className="blog-search">
            <input
              type="text"
              placeholder="Search blogs..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="search-input"
            />
            {query && (
              <div className="search-results">
                {results.length === 0 && <div className="search-empty">No results</div>}
                {results.map((r) => (
                  <Link key={r.slug} to={`/blog/${r.slug}`} className="search-result" onClick={() => setQuery("")}
                  >
                    <div className="result-title">{r.title}</div>
                    <div className="result-meta">{new Date(r.date).toLocaleDateString()}</div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </NavbarFooterWrapper>
  );
};

export default BlogPostPage;


